export class Stack<T> {
    private items: T[] = [];

    /**
     * Push an item onto the stack
     */
    push(item: T): void {
        this.items.push(item);
    }

    /**
     * Remove the top item from the stack and return it
     */
    pop(): T | undefined {
        return this.items.pop();
    }

    /**
     * Return the top item without removing it
     */
    peek(): T | undefined {
        return this.items[this.items.length - 1];
    }

    /**
     * Check if the stack is empty
     */
    isEmpty(): boolean {
        return this.items.length === 0;
    }

    /**
     * Clear the stack
     */
    clear() {
        this.items.length = 0;
    }
    /**
     * Return the number of items in the stack
     */
    get length(): number {
        return this.items.length;
    }
}
